import { createSlice } from "@reduxjs/toolkit";

import {
  loginUserAction,
  logoutUserAction,
  getUserProfileAction,
  updatePasswordAction,
  getAllUserAction,
  getAllClientsAction,
  getIndividualClientsAction,
  assignClientsToUserAction,
  getAssignedClientsToUserAction,
  getAllFinacUsersAction,
  changeFinacFirstLastNameAction,
  changeFinacUserPasswordAction,
  changeUserStatusAction,
  forgetPasswordAction,
  resetForgetPasswordAction,
  loginWithMobileNumberAction,
  loginWithMobileOtpVerifyAction,
  userProfileAction,
  // updateProfile,
  getAllAssignUserOfSingleClientAction,
  getAllFinacClientUsersAction,
  getAllFinacClientsAction,
  addRemoveToFavouriteAction,
  // addUserPofile,
  unassignedUserOfSingleClient,
  checkUniqueEmailAction,
  checkUniqueMobileNoAction,
  getFinacInternalUsersAction,
  getFinacExternalUsersAction,
  getAllFinacManagerAction,
  getAllFinacPartnerAction,
  getAttendanceDataAction,
  addAttendanceTimeAction,
  checkRecruitmentTrackerUniqueEmailAction,
  checkRecruitmentTrackerUniqueMobileNoAction,
  checkUniqueEmailSignUpAction,
  checkUniqueMobileNoSignUpAction,
  getAllCountrySignUpAction,
  getAllCitySignUpAction,
  getAllStateSignUpAction,
  getTeamDirectoryUserListAction,
  getOtpSignUpAction,
  signUpOtpVerifyAction,
  getAllFinacGovtOfficerAction,
  getGovtOfficerJobsListAction,
  getVerifyAuAccountNumberAction,
  getPincodeAction,
  signUpOtpVerifyVoucherCodeAction,
  createOrderAction,
  verifyPaymentAction,
  signUpClientAction,
  getAccountNoPaymentVoucherAction,
  finacUserListWithFiltersAction,
} from "@/redux/auth/actions";
import type { AuthType } from "@/redux/auth/authTypes";
import { initialState } from "@/redux/auth/initialState";
import { authReducer } from "@/redux/auth/reducer";

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: authReducer,
  extraReducers: (builder) => {
    builder.addCase(loginUserAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      loginUserAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, result, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            success: success,
            fetching: false,
            error: message,
            statusCode: status_code,
          };
        }

        let sideMenuList: any = [];
        let moduleList: any = [];
        let othersList: any = [];

        result?.group_menu &&
          result?.group_menu?.all_menu_details?.length > 0 &&
          result?.group_menu?.all_menu_details.map((menu: any) => {
            menu?.category === "side_menu"
              ? sideMenuList.push(menu)
              : menu?.category === "others"
                ? othersList.push(menu)
                : moduleList.push(menu);
          });
        let allMenus = result?.group_menu?.all_group_menu;
        return {
          ...state,
          fetching: false,
          token: result.user_token,
          loginData: result,
          statusCode: status_code,
          sideMenus: sideMenuList,
          modules: moduleList,
          allGroupMenus: allMenus,
          others: othersList,
        };
      }
    );

    builder.addCase(loginUserAction.rejected, (state: AuthType) => ({
      ...state,
      fetching: false,
    }));

    builder.addCase(
      loginWithMobileOtpVerifyAction.pending,
      (state: AuthType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      loginWithMobileOtpVerifyAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, result, status_code } = payload;

        let sideMenuList: any = [];
        let moduleList: any = [];

        result?.group_menu &&
          result?.group_menu?.all_menu_details?.length > 0 &&
          result?.group_menu?.all_menu_details.map((menu: any) => {
            menu?.category === "side_menu"
              ? sideMenuList.push(menu)
              : moduleList.push(menu);
          });

        let allMenus = result?.group_menu?.all_group_menu;

        if (success === 0) {
          return {
            ...state,
            success: success,
            fetching: false,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          token: result.user_token,
          loginData: result,
          statusCode: status_code,
          sideMenus: sideMenuList,
          modules: moduleList,
          allGroupMenus: allMenus,
          message: message,
        };
      }
    );

    builder.addCase(
      loginWithMobileOtpVerifyAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error.message ?? null,
      })
    );

    builder.addCase(loginWithMobileNumberAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      loginWithMobileNumberAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            success: success,
            fetching: false,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          message: message,
          success: success,
        };
      }
    );

    builder.addCase(
      loginWithMobileNumberAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error.message ?? null,
      })
    );

    builder.addCase(logoutUserAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      logoutUserAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, result } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          token: null,
        };
      }
    );

    builder.addCase(
      logoutUserAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error.message ?? null,
      })
    );

    builder.addCase(forgetPasswordAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      forgetPasswordAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, result } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success: success,
          };
        }

        return {
          ...state,
          fetching: false,
          success: success,
          resetPasswordToken: result.Temp_User_token,
        };
      }
    );

    builder.addCase(
      forgetPasswordAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error.message ?? null,
      })
    );

    builder.addCase(resetForgetPasswordAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      resetForgetPasswordAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      resetForgetPasswordAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(getUserProfileAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getUserProfileAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, result = {}, status_code } = payload;
        const { data, user_type } = result;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          userProfiledata: data,
          userType: user_type,
          statusCode: 401,
        };
      }
    );

    builder.addCase(getAllUserAction.rejected, (state: any) => ({
      ...state,

      // error: errors[0]
      fetching: false,
    }));

    builder.addCase(getAllUserAction.pending, (state: any) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(getAllUserAction.fulfilled, (state: any, { payload }) => {
      const { success, message, result = {}, status_code } = payload;
      const { data, total_count } = result;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          userDetails: result,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        userDetails: data,
        totalUserCount: total_count,
      };
    });

    builder.addCase(getUserProfileAction.rejected, (state: AuthType) => ({
      ...state,

      // error: errors[0]
      fetching: false,
    }));

    builder.addCase(userProfileAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      userProfileAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          userProfileAllData: result,
          persistUserProfileAllData: result,
          statusCode: status_code,
          message,
        };
      }
    );

    builder.addCase(
      userProfileAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(checkUniqueEmailAction.pending, (state: AuthType) => ({
      ...state,
      emailFetching: true,
    }));

    builder.addCase(
      checkUniqueEmailAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, is_duplicate, message, status_code } =
          payload?.data || {};

        if (success === 0) {
          return {
            ...state,
            emailSuccess: success,
            emailFetching: false,
            emailError: message,
            emailSatusCode: status_code,
            isEmail: is_duplicate,
          };
        }
        return {
          ...state,
          isEmail: is_duplicate,
          emailFetching: false,
          emailMessage: message,
          emailSatusCode: status_code,
          emailSuccess: success,
        };
      }
    );

    builder.addCase(
      checkUniqueEmailAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        emailFetching: false,
        emailSuccess: 0,
        emailError: error?.message ?? null,
      })
    );

    builder.addCase(
      checkRecruitmentTrackerUniqueEmailAction.pending,
      (state: AuthType) => ({
        ...state,
        recruitmentTrackerUniqueEmailFetching: true,
      })
    );

    builder.addCase(
      checkRecruitmentTrackerUniqueEmailAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, is_duplicate, message, status_code } =
          payload?.data || {};

        if (success === 0) {
          return {
            ...state,
            emailSuccess: success,
            recruitmentTrackerUniqueEmailFetching: false,
            emailError: message,
          };
        }
        return {
          ...state,
          recruitmentTrackerUniqueEmailFetching: false,
          recruitmentTrackerUniqueEmailMessage: message,
        };
      }
    );

    builder.addCase(
      checkRecruitmentTrackerUniqueEmailAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        recruitmentTrackerUniqueEmailFetching: false,
        emailSuccess: 0,
        emailError: error?.message ?? null,
      })
    );

    builder.addCase(
      checkRecruitmentTrackerUniqueMobileNoAction.pending,
      (state: AuthType) => ({
        ...state,
        recruitmentTrackerUniqueMobileFetching: true,
      })
    );

    builder.addCase(
      checkRecruitmentTrackerUniqueMobileNoAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, is_duplicate, message, status_code } =
          payload?.data || {};

        if (success === 0) {
          return {
            ...state,
            emailSuccess: success,
            recruitmentTrackerUniqueMobileFetching: false,
            emailError: message,
          };
        }
        return {
          ...state,
          recruitmentTrackerUniqueMobileFetching: false,
          recruitmentTrackerUniqueMobileMessage: message,
        };
      }
    );

    builder.addCase(
      checkRecruitmentTrackerUniqueMobileNoAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        recruitmentTrackerUniqueMobileFetching: false,
        emailSuccess: 0,
        emailError: error?.message ?? null,
      })
    );

    builder.addCase(checkUniqueMobileNoAction.pending, (state: AuthType) => ({
      ...state,
      mobileFetching: true,
    }));

    builder.addCase(
      checkUniqueMobileNoAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, is_duplicate, message, status_code } =
          payload?.data || {};

        if (success === 0) {
          return {
            ...state,
            mobileSuccess: success,
            mobileFetching: false,
            mobileError: message,
            mobileSatusCode: status_code,
            isMobileNo: is_duplicate,
          };
        }
        return {
          ...state,
          isMobileNo: is_duplicate,
          mobileFetching: false,
          mobileMessage: message,
          mobileSatusCode: status_code,
          mobileSuccess: success,
        };
      }
    );

    builder.addCase(
      checkUniqueMobileNoAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        mobileFetching: false,
        mobileSuccess: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(updatePasswordAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      updatePasswordAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, result = {}, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            result,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
        };
      }
    );

    builder.addCase(updatePasswordAction.rejected, (state: AuthType) => ({
      ...state,

      // error: errors[0]
      fetching: false,
    }));

    builder.addCase(getAllClientsAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getAllClientsAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, result = {}, status_code } = payload;
        const { data = {}, total_count } = result || {};

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
            success: 0,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          clientList: data,
          totalClientsCount: total_count,
        };
      }
    );

    builder.addCase(getAllClientsAction.rejected, (state: AuthType) => ({
      ...state,
      fetching: false,
    }));

    builder.addCase(
      getAllAssignUserOfSingleClientAction.pending,
      (state: AuthType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllAssignUserOfSingleClientAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          allAssignUserOfSingleClient: result,
        };
      }
    );

    builder.addCase(
      getAllAssignUserOfSingleClientAction.rejected,
      (state: AuthType) => ({
        ...state,
        fetching: false,
      })
    );

    builder.addCase(
      unassignedUserOfSingleClient.pending,
      (state: AuthType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      unassignedUserOfSingleClient.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
            success: 0,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      unassignedUserOfSingleClient.rejected,
      (state: AuthType) => ({
        ...state,
        fetching: false,
      })
    );

    builder.addCase(getIndividualClientsAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getIndividualClientsAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, message, result = [] } = payload;

        let finalIds: any[] = [];
        result?.filter((item: any) => {
          finalIds.push(item.client_id);
        });

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          individualClientList: result,
          clientCodeList: finalIds,
        };
      }
    );

    builder.addCase(
      getIndividualClientsAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(assignClientsToUserAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      assignClientsToUserAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, result = {}, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      assignClientsToUserAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAssignedClientsToUserAction.pending,
      (state: AuthType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAssignedClientsToUserAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, result, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        // Accumulate each listed client's currency by client_code so report /
        // invoice pages can resolve the currency of the client they're viewing
        // regardless of the global last-selected currency or which tab set it.
        const mergedCurrencyMap: {
          [k: string]: {
            currencySign?: string;
            currencyName?: string;
            currencyShortForm?: string;
          };
        } = { ...(state.clientCurrencyMap || {}) };
        [
          result?.data,
          result?.fav_client_data,
          result?.unfav_client_data,
        ].forEach((list: any) => {
          if (!Array.isArray(list)) return;
          list.forEach((client: any) => {
            if (
              (client?.client_code || client?.client_code === 0) &&
              (client?.currency_sign ||
                client?.currency_name ||
                client?.currency_short_form)
            ) {
              mergedCurrencyMap[String(client.client_code)] = {
                currencySign: client.currency_sign ?? "",
                currencyName: client.currency_name ?? "",
                currencyShortForm: client.currency_short_form ?? "",
              };
            }
          });
        });

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          assignedClientsToUserList: result?.data,
          favouriteClientsData: result?.fav_client_data,
          unFavouriteClientsData: result?.unfav_client_data,
          totalUnfavouriteClient: result?.total_unfav_count,
          clientCurrencyMap: mergedCurrencyMap,
        };
      }
    );

    builder.addCase(
      getAssignedClientsToUserAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(getAllFinacUsersAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getAllFinacUsersAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, result, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          finacUsersList: result,
          totalUserCount: result?.total_count,
        };
      }
    );

    builder.addCase(
      getAllFinacUsersAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(getAllFinacManagerAction.pending, (state: AuthType) => ({
      ...state,
      managerFetching: true,
    }));

    builder.addCase(
      getAllFinacManagerAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, result, message } = payload;
        if (success === 0) {
          return {
            ...state,
            managerFetching: false,
            managerSuccess: success,
            managerStatusCode: status_code,
            managerError: message,
          };
        }

        return {
          ...state,
          managerFetching: false,
          managerStatusCode: status_code,
          finacManagerList: result?.data,
          totalManagerCount: result?.total_count,
        };
      }
    );

    builder.addCase(
      getAllFinacManagerAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        managerFetching: false,
        managerError: error?.message ?? null,
      })
    );

    builder.addCase(getAllFinacPartnerAction.pending, (state: AuthType) => ({
      ...state,
      partnerFetching: true,
    }));

    builder.addCase(
      getAllFinacPartnerAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, result, message } = payload;
        if (success === 0) {
          return {
            ...state,
            partnerFetching: false,
            partnerSuccess: success,
            partnerStatusCode: status_code,
            partnerError: message,
          };
        }

        return {
          ...state,
          partnerFetching: false,
          partnerStatusCode: status_code,
          finacPartnerList: result?.data,
          totalPartnerCount: result?.total_count,
        };
      }
    );

    builder.addCase(
      getAllFinacPartnerAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        partnerFetching: false,
        partnerError: error?.message ?? null,
      })
    );

    builder.addCase(
      getAllFinacGovtOfficerAction.pending,
      (state: AuthType) => ({
        ...state,
        gotvOfficerFetching: true,
      })
    );

    builder.addCase(
      getAllFinacGovtOfficerAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, result, message } = payload;
        if (success === 0) {
          return {
            ...state,
            gotvOfficerFetching: false,
            govtOfficerSuccess: success,
            govtOfficerStatusCode: status_code,
            govtOfficerError: message,
          };
        }

        return {
          ...state,
          gotvOfficerFetching: false,
          govtOfficerStatusCode: status_code,
          finacGovtOfficerList: result?.data,
          totalGovtOfficerCount: result?.total_count,
        };
      }
    );

    builder.addCase(
      getAllFinacGovtOfficerAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        gotvOfficerFetching: false,
        govtOfficerError: error?.message ?? null,
      })
    );

    builder.addCase(getFinacInternalUsersAction.pending, (state: AuthType) => ({
      ...state,
      internalFetching: true,
    }));

    builder.addCase(
      getFinacInternalUsersAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, result, message } = payload;
        if (success === 0) {
          return {
            ...state,
            internalFetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          internalFetching: false,
          statusCode: status_code,
          internalUsersList: result?.data,
          internalUserCount: result?.total_count,
        };
      }
    );

    builder.addCase(
      getFinacInternalUsersAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        internalFetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(getFinacExternalUsersAction.pending, (state: AuthType) => ({
      ...state,
      externalFetching: true,
    }));

    builder.addCase(
      getFinacExternalUsersAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, result, message } = payload;
        if (success === 0) {
          return {
            ...state,
            externalFetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          externalFetching: false,
          statusCode: status_code,
          externalUsersList: result?.data,
          externalUserCount: result?.total_count,
        };
      }
    );

    builder.addCase(
      getFinacExternalUsersAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        externalFetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(getAllFinacClientsAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getAllFinacClientsAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, result, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          finacClientsList: result,
        };
      }
    );

    builder.addCase(
      getAllFinacClientsAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAllFinacClientUsersAction.pending,
      (state: AuthType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllFinacClientUsersAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, result, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          finacClientUsersList: result,
        };
      }
    );

    builder.addCase(
      getAllFinacClientUsersAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      changeFinacUserPasswordAction.pending,
      (state: AuthType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      changeFinacUserPasswordAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      changeFinacUserPasswordAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      changeFinacFirstLastNameAction.pending,
      (state: AuthType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      changeFinacFirstLastNameAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      changeFinacFirstLastNameAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(changeUserStatusAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      changeUserStatusAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      changeUserStatusAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(addRemoveToFavouriteAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      addRemoveToFavouriteAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          message: message,
        };
      }
    );

    builder.addCase(
      addRemoveToFavouriteAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(addAttendanceTimeAction.pending, (state: AuthType) => ({
      ...state,
      attendenceFetching: true,
    }));

    builder.addCase(
      addAttendanceTimeAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            attendenceFetching: false,
            attendenceSuccess: success,
            attendanceStatusCode: status_code,
            attendenceError: message,
          };
        }

        return {
          ...state,
          attendenceFetching: false,
          attendenceSuccess: success,
          attendanceStatusCode: status_code,
          message: message,
        };
      }
    );

    builder.addCase(
      addAttendanceTimeAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        attendenceFetching: false,
        attendenceSuccess: 0,
        attendenceError: error?.message ?? null,
      })
    );

    builder.addCase(getAttendanceDataAction.pending, (state: AuthType) => ({
      ...state,
      attendenceFetching: true,
    }));

    builder.addCase(
      getAttendanceDataAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, message, result } = payload;
        if (success === 0) {
          return {
            ...state,
            attendenceFetching: false,
            attendenceSuccess: success,
            statusCode: status_code,
            attendenceError: message,
          };
        }

        return {
          ...state,
          attendenceFetching: false,
          attendenceSuccess: success,
          statusCode: status_code,
          message: message,
          attendenceData: result?.response,
          totalAttendanceHours: result?.total_time,
        };
      }
    );

    builder.addCase(
      getAttendanceDataAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        attendenceFetching: false,
        attendenceSuccess: 0,
        attendenceError: error?.message ?? null,
      })
    );

    builder.addCase(
      checkUniqueEmailSignUpAction.pending,
      (state: AuthType) => ({
        ...state,
        signUpEmailFetching: true,
      })
    );

    builder.addCase(
      checkUniqueEmailSignUpAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, is_duplicate, message, status_code } =
          payload?.data || {};

        if (success === 0) {
          return {
            ...state,
            signUpEmailSuccess: success,
            signUpEmailFetching: false,
            signUpEmailError: message,
            signUpEmailSatusCode: status_code,
            isSignupEmail: is_duplicate,
          };
        }
        return {
          ...state,
          isSignupEmail: is_duplicate,
          signUpEmailFetching: false,
          signUpEmailMessage: message,
          signUpEmailSatusCode: status_code,
          signUpEmailSuccess: success,
        };
      }
    );

    builder.addCase(
      checkUniqueEmailSignUpAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        signUpEmailFetching: false,
        signUpEmailSuccess: 0,
        signUpEmailError: error?.message ?? null,
      })
    );

    builder.addCase(
      checkUniqueMobileNoSignUpAction.pending,
      (state: AuthType) => ({
        ...state,
        signUpMobileFetching: true,
      })
    );

    builder.addCase(
      checkUniqueMobileNoSignUpAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, is_duplicate, message, status_code } =
          payload?.data || {};

        if (success === 0) {
          return {
            ...state,
            signUpMobileSuccess: success,
            signUpMobileFetching: false,
            signUpMobileError: message,
            signUpMobileSatusCode: status_code,
            isSignUpMobileNo: is_duplicate,
          };
        }
        return {
          ...state,
          isSignUpMobileNo: is_duplicate,
          signUpMobileFetching: false,
          singUpMobileMessage: message,
          signUpMobileSatusCode: status_code,
          signUpMobileSuccess: success,
        };
      }
    );

    builder.addCase(
      checkUniqueMobileNoSignUpAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        signUpMobileFetching: false,
        signUpMobileSuccess: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(getAllCountrySignUpAction.pending, (state: AuthType) => ({
      ...state,
      countryFetching: true,
    }));

    builder.addCase(
      getAllCountrySignUpAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, result, status_code, count } = payload;

        if (success === 0) {
          return {
            ...state,
            countryFetching: false,
            countrySuccess: success,
            statusCode: status_code,
            countryError: message,
          };
        }

        return {
          ...state,
          countryFetching: false,
          statusCode: status_code,
          countryList: result,
          countrySuccess: success,
          countryListTotalCount: count ? count : 0,
        };
      }
    );

    builder.addCase(
      getAllCountrySignUpAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        countryFetching: false,
        countrySuccess: 0,
        countryError: error?.message ?? null,
      })
    );

    builder.addCase(getAllStateSignUpAction.pending, (state: AuthType) => ({
      ...state,
      stateFetching: true,
    }));

    builder.addCase(
      getAllStateSignUpAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, result, status_code, count, is_state } =
          payload;

        if (success === 0) {
          return {
            ...state,
            stateFetching: false,
            stateSuccess: success,
            statusCode: status_code,
            stateError: message,
          };
        }

        return {
          ...state,
          stateFetching: false,
          statusCode: status_code,
          stateList: result,
          stateSuccess: success,
          stateListTotalCount: count,
          isState: is_state,
        };
      }
    );

    builder.addCase(
      getAllStateSignUpAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        stateFetching: false,
        stateSuccess: 0,
        stateError: error?.message ?? null,
      })
    );

    builder.addCase(getAllCitySignUpAction.pending, (state: AuthType) => ({
      ...state,
      countryFetching: true,
    }));

    builder.addCase(
      getAllCitySignUpAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, result, status_code, count, is_city } =
          payload;

        if (success === 0) {
          return {
            ...state,
            countryFetching: false,
            citySuccess: success,
            statusCode: status_code,
            cityError: message,
          };
        }

        return {
          ...state,
          countryFetching: false,
          statusCode: status_code,
          cityList: result,
          citySuccess: success,
          cityListTotalCount: count ? count : 0,
          isCity: is_city,
        };
      }
    );

    builder.addCase(
      getAllCitySignUpAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        countryFetching: false,
        citySuccess: 0,
        cityError: error?.message ?? null,
      })
    );

    builder.addCase(signUpClientAction.pending, (state: AuthType) => {
      {
        return {
          ...state,
          fetching: true,
        };
      }
    });

    builder.addCase(
      signUpClientAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, result, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            success: success,
            fetching: false,
            error: message,
            statusCode: status_code,
          };
        }

        let sideMenuList: any = [];
        let moduleList: any = [];
        let othersList: any = [];

        result?.group_menu &&
          result?.group_menu?.all_menu_details?.length > 0 &&
          result?.group_menu?.all_menu_details.map((menu: any) => {
            menu?.category === "side_menu"
              ? sideMenuList.push(menu)
              : menu?.category === "others"
                ? othersList.push(menu)
                : moduleList.push(menu);
          });

        let allMenus = result?.group_menu?.all_group_menu;
        return {
          ...state,
          fetching: false,
          token: result.user_token,
          loginData: result,
          statusCode: status_code,
          sideMenus: sideMenuList,
          modules: moduleList,
          allGroupMenus: allMenus,
          others: othersList,
        };
      }
    );

    builder.addCase(signUpClientAction.rejected, (state: AuthType) => {
      {
        return {
          ...state,
          fetching: false,
        };
      }
    });

    builder.addCase(
      getTeamDirectoryUserListAction.pending,
      (state: AuthType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getTeamDirectoryUserListAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, result, message, total_count } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          teamDirectoryUsersData: result,
          totalTeamDirectoryUsersCount: total_count,
        };
      }
    );

    builder.addCase(
      getTeamDirectoryUserListAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(getOtpSignUpAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getOtpSignUpAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            success: success,
            fetching: false,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          message: message,
          success: success,
        };
      }
    );

    builder.addCase(
      getOtpSignUpAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(signUpOtpVerifyAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      signUpOtpVerifyAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            success: success,
            fetching: false,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          message: message,
          success: success,
        };
      }
    );

    builder.addCase(
      signUpOtpVerifyAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getGovtOfficerJobsListAction.pending,
      (state: AuthType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getGovtOfficerJobsListAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, result, message, total_count } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          totalJobListCount: total_count,
          govtOfficerJobsList: result,
        };
      }
    );

    builder.addCase(
      getGovtOfficerJobsListAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getVerifyAuAccountNumberAction.pending,
      (state: AuthType) => ({
        ...state,
        auAccountNumberFetching: true,
      })
    );

    builder.addCase(
      getVerifyAuAccountNumberAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, result, status_code, count, is_state } =
          payload;

        if (success === 0) {
          return {
            ...state,
            auAccountNumberFetching: false,
            success: success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          auAccountNumberFetching: false,
          statusCode: status_code,
          auAccountNumberVerifyData: result?.data,
          isAccountNumberVerified: result?.data?.account_exists,
          verifyAccountNumberMessage: result?.data?.message,

          success: success,
        };
      }
    );

    builder.addCase(
      getVerifyAuAccountNumberAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        auAccountNumberFetching: false,
        success: 0,
        error: error?.message ?? null,
        verifyAccountNumberMessage: error?.message ?? null,
      })
    );

    builder.addCase(getPincodeAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getPincodeAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, result, status_code, count, is_state } =
          payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          specificPincodeInformation: result,
          success: success,
        };
      }
    );

    builder.addCase(
      getPincodeAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAccountNoPaymentVoucherAction.pending,
      (state: AuthType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAccountNoPaymentVoucherAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          accountPaymentVoucherVerification: result,
          success: success,
        };
      }
    );

    builder.addCase(
      getAccountNoPaymentVoucherAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      signUpOtpVerifyVoucherCodeAction.pending,
      (state: AuthType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      signUpOtpVerifyVoucherCodeAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, status_code, result } = payload;
        if (success === 0) {
          return {
            ...state,
            verifyVoucherSuccess: success,
            fetching: false,
            verifyVoucherMessage: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          verifyVoucherMessage: message,
          verifyVoucherSuccess: success,
          isVoucherCodeVerified: result?.voucher_code_verified,
        };
      }
    );

    builder.addCase(
      signUpOtpVerifyVoucherCodeAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        verifyVoucherMessage: error.message ?? null,
      })
    );

    builder.addCase(createOrderAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      createOrderAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            success: success,
            fetching: false,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          message: message,
          success: success,
        };
      }
    );

    builder.addCase(
      createOrderAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error.message ?? null,
      })
    );

    builder.addCase(verifyPaymentAction.pending, (state: AuthType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      verifyPaymentAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            success: success,
            fetching: false,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          message: message,
          success: success,
        };
      }
    );

    builder.addCase(
      verifyPaymentAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      finacUserListWithFiltersAction.pending,
      (state: AuthType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      finacUserListWithFiltersAction.fulfilled,
      (state: AuthType, { payload }) => {
        const { success, status_code, result, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          filteredFinacUserList: result?.data,
          totalFilteredFinacUserCount: result?.total_count,
        };
      }
    );

    builder.addCase(
      finacUserListWithFiltersAction.rejected,
      (state: AuthType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );
  },
});

export const {
  resetError: resetAuthError,
  resetSuccess: resetAuthSuccess,
  resetAuthMessage,
  resetSession,
  resetUserDetails,
  resetAuthFetching,
  resetIndividualClientList,
  resetResetPasswordToken,
  resetAllGroupMenuList,
  resetUserProfiledata,
  resetUserProfileAllData,
  resetClientList,
  resetAssignedClientsToUserList,
  resetFinacUsersList,
  resetFinacClientUsersList,
  resetPersistUserProfileAllData,
  resetUnFavouriteClientToUserList,
  resetFavouriteClientToUserList,
  resetAllAssignUserOfSingleClient,
  resetTotalUserCount,
  resetTotalClientsCount,
  resetEmailSuccess,
  resetEmailSatusCode,
  resetEmailError,
  resetEmailMessage,
  resetEmailFetching,
  resetIsEmail,
  resetMobileSuccess,
  resetMobileSatusCode,
  resetMobileError,
  resetMobileMessage,
  resetMobileFetching,
  resetIsMobileNo,
  resetFinacManagerList,
  resetFinacPartnerList,
  resetTotalManagerCount,
  setClientCurrencyDetails,
  resetAttendenceData,
  resetAttendenceError,
  resetAttendenceSuccess,
  setLocationDetails,
  resetLocationDetails,
  resetAttendanceStatusCode,
  resetTotalUnfavouriteClient,
  setCompanyName,
  resetCompanyName,
  resetRecruitmentTrackerUniqueEmailMessage,
  resetRecruitmentTrackerUniqueMobileMessage,
  resetSignUpEmailSuccess,
  resetSignUpEmailSatusCode,
  resetSignUpEmailError,
  resetSignUpEmailMessage,
  resetSignUpEmailFetching,
  resetIsSignupEmail,
  resetSignUpMobileSuccess,
  resetSignUpMobileSatusCode,
  resetSignUpMobileError,
  resetSingUpMobileMessage,
  resetSignUpMobileFetching,
  resetIsSignUpMobileNo,
  resetStateList,
  resetStateListTotalCount,
  resetStateFetching,
  resetCityList,
  resetCityListTotalCount,
  resetCityFetching,
  resetCountryList,
  resetCountryListTotalCount,
  resetTeamDirectoryTotalCount,
  resetTeamDirectoryUsersList,
  resetCountrySuccess,
  resetCountryError,
  resetStateError,
  resetStateSuccess,
  resetCityError,
  resetCitySuccess,
  resetFinacGovtOfficerList,
  resetTotalGovtOfficerCount,
  resetGovtOfficerJobsList,
  resetTotalJobListCount,
  resetAuAccountNumberVerifyData,
  resetspecificPincodeInformation,
  resetVerifyVoucherSuccess,
  resetVerifyVoucherMessage,
  resetIsAccountNumberVerified,
  resetVerifyAccountNumberMessage,
  resetAccountPaymentVoucherVefication,
  resetIsVoucherCodeVerified,
  set401Modal,
  clear401Modal,
  setNetworkErrorModal,
  clearNetworkErrorModal,
  resetFilteredFinacUserList,
  resetTotalFilteredFinacUserCount,
} = authSlice.actions;
